import { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'
import { styled } from '@mui/material'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

const NewProgress4 = ({ phoneType, nowPage, Code }) => {

  const { t } = useTranslation('commonAndroid')
  const [showData, setShowData] = useState([])
  const dom = useRef(null)

  // 其他品牌手机图片文案
  const otherArr = [
    [
      { img1: '/images/bind/other/config1-1.jpg', img2: '', imgSize1: { w: 180, h: 166 }, imgSize2: {}, text: t('Follow the guidelines in the app click Lets Start and Install in sequence') },
      { img1: '/images/bind/other/config1-2.jpg', img2: '', imgSize1: { w: 180, h: 100 }, imgSize2: {}, text: t('Click Setting on the pop-up') },
      { img1: '/images/bind/other/config1-3.jpg', img2: '', imgSize1: { w: 180, h: 90 }, imgSize2: {}, text: t('Tap the button set to Allow') },
      { img1: '/images/bind/other/config1-4.jpg', img2: '', imgSize1: { w: 180, h: 90 }, imgSize2: {}, text: t('Click Install on the pop-up') }
    ],
    [
      { img1: '/images/bind/other/config2-2.jpg', img2: '', imgSize1: { w: 180, h: 98 }, imgSize2: {}, text: t('Click OK on the pop-up') },
      { img1: '/images/bind/other/config2-1.jpg', img2: '', imgSize1: { w: 180, h: 130 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/other/config2-3.jpg', img2: '/images/bind/other/config2-4.jpg', imgSize1: { w: 180, h: 130 }, imgSize2: { w: 180, h: 98 }, text: t('Scroll until see Update service then click and set to Allow') }
    ],
    [
      { img1: '/images/bind/other/config3-1.jpg', img2: '', imgSize1: { w: 180, h: 128 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/other/config3-2.jpg', img2: '', imgSize1: { w: 180, h: 146 }, imgSize2: {}, text: t('Select Update service in Accessibility') },
      { img1: '/images/bind/other/config3-3.jpg', img2: '', imgSize1: { w: 180, h: 205 }, imgSize2: {}, text: t('Tap the button then select Allow') }
    ],
    [
      { img1: '/images/bind/other/config4-1.jpg', img2: '', imgSize1: { w: 180, h: 192 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Choose Allow on all pop-ups') }
    ],
    [
      { img1: '/images/bind/other/config5-1.jpg', img2: '', imgSize1: { w: 180, h: 135 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/other/config5-2.jpg', img2: '', imgSize1: { w: 180, h: 160 }, imgSize2: {}, text: t('Select Permissions in this page') },
      { img1: '/images/bind/other/config5-3.jpg', img2: '', imgSize1: { w: 180, h: 160 }, imgSize2: {}, text: t('Select Location and set to Allow all the time') }
    ],
    [
      { img1: '/images/bind/other/config6-1.jpg', img2: '', imgSize1: { w: 180, h: 163 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/other/config6-2.jpg', img2: '', imgSize1: { w: 180, h: 307 }, imgSize2: {}, text: t('Select Activate this device admin app') }
    ]
  ]

  // 三星手机图片文案
  const samsungArr = [
    [
      { img1: '/images/bind/samsung/config1-1.jpg', img2: '', imgSize1: { w: 180, h: 200 }, imgSize2: {}, text: t('Follow the guidelines in the app click Lets Start and Install in sequence') },
      { img1: '/images/bind/samsung/config1-2.jpg', img2: '', imgSize1: { w: 180, h: 120 }, imgSize2: {}, text: t('Click Setting on the pop-up') },
      { img1: '/images/bind/samsung/config1-3.jpg', img2: '', imgSize1: { w: 180, h: 100 }, imgSize2: {}, text: t('Scroll until fine Update service set to Allow and then click Install in pop-up') },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Then go back Continue page') }
    ],
    [
      { img1: '/images/bind/samsung/config2-1.jpg', img2: '', imgSize1: { w: 180, h: 178 }, imgSize2: {}, text: t('Click ok to unstall the installation package') },
      { img1: '/images/bind/samsung/config2-2.jpg', img2: '', imgSize1: { w: 180, h: 109 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/samsung/config2-3.jpg', img2: '', imgSize1: { w: 180, h: 130 }, imgSize2: {}, text: t('Scroll until see Update service then click and set to Allow') }
    ],
    [
      { img1: '/images/bind/samsung/config3-1.jpg', img2: '', imgSize1: { w: 180, h: 103 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/samsung/config3-2.jpg', img2: '', imgSize1: { w: 180, h: 126 }, imgSize2: {}, text: t('Select Installed apps in Accessibility') },
      { img1: '/images/bind/samsung/config3-3.jpg', img2: '/images/bind/samsung/config3-4.jpg', imgSize1: { w: 180, h: 86.67 }, imgSize2: { w: 180, h: 159 }, text: t('Select Update service then set off to on And click Allow in pop-up') }
    ],
    [
      { img1: '/images/bind/samsung/config4-1.jpg', img2: '', imgSize1: { w: 180, h: 192 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Choose Allow on all pop-ups') }
    ],
    [
      { img1: '/images/bind/samsung/config5-1.jpg', img2: '', imgSize1: { w: 180, h: 135 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/samsung/config5-2.jpg', img2: '', imgSize1: { w: 180, h: 150 }, imgSize2: {}, text: t('Select Permissions in this page') },
      { img1: '/images/bind/samsung/config5-3.jpg', img2: '', imgSize1: { w: 180, h: 160 }, imgSize2: {}, text: t('Select Location and set to Allow all the time') }
    ],
    [
      { img1: '/images/bind/samsung/config6-1.jpg', img2: '', imgSize1: { w: 180, h: 163 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/samsung/config6-2.jpg', img2: '', imgSize1: { w: 180, h: 170 }, imgSize2: {}, text: t('Select Activate in this page') }
    ]
  ]

  // 小米手机图片文案
  const xiaomiArr = [
    [
      { img1: '/images/bind/xiaomi/config1-1.jpg', img2: '', imgSize1: { w: 180, h: 120 }, imgSize2: {}, text: t('Follow the guidelines in the app click Lets Start and Install in sequence') },
      { img1: '/images/bind/xiaomi/config1-2.jpg', img2: '', imgSize1: { w: 180, h: 75 }, imgSize2: {}, text: t('Click Setting on the pop-up') },
      { img1: '/images/bind/xiaomi/config1-3.jpg', img2: '', imgSize1: { w: 180, h: 80 }, imgSize2: {}, text: t('Tap the button set to Allow') },
      { img1: '/images/bind/xiaomi/config1-4.jpg', img2: '/images/bind/xiaomi/config1-5.jpg', imgSize1: { w: 180, h: 54 }, imgSize2: { w: 180, h: 65 }, text: t('Click Ok after 10 seconds then select Install on the pop-up') },
    ],
    [
      { img1: '/images/bind/xiaomi/config2-1.jpg', img2: '', imgSize1: { w: 180, h: 90 }, imgSize2: {}, text: t('Click ok to unstall the installation package') },
      { img1: '/images/bind/xiaomi/config2-2.jpg', img2: '', imgSize1: { w: 180, h: 121.11 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/xiaomi/config2-3.jpg', img2: '/images/bind/xiaomi/config2-4.jpg', imgSize1: { w: 180, h: 94 }, imgSize2: { w: 180, h: 100 }, text: t('Scroll until see Update service then click and set to Allow') }
    ],
    [
      { img1: '/images/bind/xiaomi/config3-1.jpg', img2: '', imgSize1: { w: 180, h: 110 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/xiaomi/config3-2.jpg', img2: '', imgSize1: { w: 180, h: 64 }, imgSize2: {}, text: t('Select Downloaded apps') },
      {
        img1: '/images/bind/xiaomi/config3-3.jpg', img2: '/images/bind/xiaomi/config3-4.jpg', img3: '/images/bind/xiaomi/config3-5.jpg',
        imgSize1: { w: 180, h: 100 }, imgSize2: { w: 180, h: 90 }, imgSize3: { w: 180, h: 70 }, text: t('Click Update service set off to on And Click OK after 10 secnds')
      },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Then go back to Continue page') }
    ],
    [
      { img1: '/images/bind/xiaomi/config4-1.jpg', img2: '', imgSize1: { w: 180, h: 192 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Choose Allow on all pop-ups') }
    ],
    [
      { img1: '/images/bind/xiaomi/config5-1.jpg', img2: '', imgSize1: { w: 180, h: 122.73 }, imgSize2: {}, text: t('Follow the guidelines in the app click Continue') },
      { img1: '/images/bind/xiaomi/config5-2.jpg', img2: '', imgSize1: { w: 180, h: 185 }, imgSize2: {}, text: t('Select App Permissions in this page') },
      { img1: '/images/bind/xiaomi/config5-3.jpg', img2: '', imgSize1: { w: 180, h: 161 }, imgSize2: {}, text: t('Select Location and set to Allow all the time') }
    ],
    [
      {
        img1: '/images/bind/xiaomi/config6-1.jpg', img2: '/images/bind/xiaomi/config6-2.jpg', img3: '/images/bind/xiaomi/config6-3.jpg', img4: '/images/bind/xiaomi/config6-4.jpg',
        imgSize1: { w: 180, h: 90 }, imgSize2: { w: 180, h: 188 }, imgSize3: { w: 180, h: 100 }, imgSize4: { w: 180, h: 90 },
        text: t('Click Continue and select Activate this device admin app Then go back Continue page and click Continue again')
      },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Repeat this operation three times selecting No restrictions then tap Update service to on in sequence') },
      { img1: '', img2: '', imgSize1: {}, imgSize2: {}, text: t('Then go back to Continue page and click it again') }
    ]
  ]

  useEffect(() => {
    if (nowPage !== 12) {
      switch (phoneType) {
        case 'other':
          setShowData(otherArr[nowPage - 6])
          break
        case 'samsung':
          setShowData(samsungArr[nowPage - 6])
          break
        case 'xiaomi':
          setShowData(xiaomiArr[nowPage - 6])
          break
      }
    }
  }, [phoneType, nowPage])

  useEffect(() => {
    dom.current?.scrollTo({
      top: 0,
      behavior: 'smooth' // 平滑滚动
    })
  }, [nowPage])

  const StepProgress = ({ current = 3, total = 6 }) => {
    const barWidth = 72 // 宽度

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <>
      <StepProgress />
      <ScrollDiv ref={dom} className='!h-[calc(var(--vh2)*100-180px)] pb-2 mx-[30px] flex flex-col items-center overflow-auto' >
        {/* <span className='w-full flex justify-center items-center text-[20px] text-[#222222] font-[400] leading-[28px] fixed top-[60px] bg-[#FFFFFF]'>{nowPage - 5}/7</span> */}

        {/* 前6页内容 */}
        {nowPage !== 12 ?
          <div className='flex flex-col items-center Mlg:mt-[28px]' >
            <ul>
              {
                showData.map((item, index) => (
                  <li key={index} className='flex flex-col items-center justify-center'>
                    {item.img1 && <Image src={item.img1} width={item.imgSize1.w} height={item.imgSize1.h} alt='img1' className='mt-[12px] mb-[10px] rounded-[18px]' style={{ width: `${item.imgSize1.w}px`, height: `auto` }} />}
                    {item.img2 && <Image src={item.img2} width={item.imgSize2.w} height={item.imgSize2.h} alt='img2' className='mb-[10px] rounded-[18px]' style={{ width: `${item.imgSize2.w}px`, height: `auto` }} />}
                    {item.img3 && <Image src={item.img3} width={item.imgSize3.w} height={item.imgSize3.h} alt='img3' className='mb-[10px] rounded-[18px]' style={{ width: `${item.imgSize3.w}px`, height: `auto` }} />}
                    {item.img4 && <Image src={item.img4} width={item.imgSize4.w} height={item.imgSize4.h} alt='img4' className='mb-[10px] rounded-[18px]' style={{ width: `${item.imgSize4.w}px`, height: `auto` }} />}
                    <div className={`w-full flex justify-start items-start ${item.img1 === '' && item.img2 === '' ? 'mt-4' : ''}`}>
                      <span className={`w-[20px] min-w-[20px] h-[20px] text-[14px] ${index === 0 ? 'bg-[#2A99FF] text-[#FFFFFF]' : ''} font-[500] leading-[18px] flex justify-center items-center mr-2 rounded-[10px]`}>{index + 1}.</span>
                      <p className='text-[16px] font-[400] leading-[24px]' dangerouslySetInnerHTML={{ __html: item.text }}></p>
                    </div>
                  </li>
                ))
              }
            </ul>
          </div >
          :
          <div className='flex flex-col items-center' >
            <p className='text-[24px] Mlg:text-[20px] text-black font-[700] leading-[36px] Mlg:leading-[30px]'><strong>{t('Install Msafely on the target phone')}</strong></p>
            <p className='w-full mt-3 text-[#222222] text-[14px] leading-[21px] text-start'>{t('Enter the registration code in the final step of the Msafely app')}</p>
            <p className='text-[42px] text-[#454CFF] font-[600] leading-[60px] mt-[6px]'>{Code}</p>
            <Image src='/images/bind/other/step1.webp' width={230} height={360} alt='img1' className='smj:w-[230px] w-[345px] h-auto mt-[32px]' />
          </div>
        }
      </ScrollDiv >
    </>
  )
}

export default NewProgress4